interface VisualizationAttribute {
    id?: string | null;
    value?: string | null;
    property?: { alias?: string | null } | null;
}

/**
 * Extracts the external visualization link from a node's attribute list.
 * The attribute has no property definition, so it is matched by its id suffix
 * (urn:installed-base-node-attribute:<nodeId>:visualizationUrl); the alias
 * check covers the property ever being populated. The value itself is not
 * validated — but a bare host/IP ("192.168.0.10:8080") in a raw href would
 * resolve as a path relative to our app, so a missing scheme gets http://.
 */
export const getVisualizationUrl = (
    attributes?: Array<VisualizationAttribute | null> | null
): string | null => {
    const attribute = (attributes ?? []).find(
        (a) => a?.id?.endsWith(':visualizationUrl') || a?.property?.alias === 'visualizationUrl'
    );
    const value = attribute?.value?.trim();
    if (!value) return null;
    return value.includes('://') ? value : `http://${value}`;
};
